import { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { getCvBlob, downloadCv, hasUploadedCv } from "@/lib/demo/cv";
import { fullName } from "@/lib/demo/utils";
import { useI18n } from "@/lib/i18n/i18n";

export const CvDialog = ({ participant, onClose }) => {
  const [url, setUrl] = useState(null);
  const { t } = useI18n();

  useEffect(() => {
    if (!participant) return undefined;
    const u = URL.createObjectURL(getCvBlob(participant));
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [participant]);

  return (
    <Dialog open={!!participant} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[88vh] max-w-4xl flex-col gap-4 p-5 sm:p-6" data-testid="cv-dialog">
        {participant && (
          <>
            <DialogHeader className="flex-row items-center justify-between gap-4 space-y-0 pr-8">
              <div className="flex min-w-0 items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-upv-light text-upv"><FileText className="h-5 w-5" /></span>
                <div className="min-w-0 text-left">
                  <DialogTitle className="truncate font-mono text-sm" data-testid="cv-dialog-filename">{participant.cvFileName}</DialogTitle>
                  <DialogDescription className="text-xs">
                    {fullName(participant)} · {t(hasUploadedCv(participant) ? "PDF subido por el participante" : "Currículum de ejemplo (demo)")}
                  </DialogDescription>
                </div>
              </div>
              <Button size="sm" variant="outline" onClick={() => downloadCv(participant)} data-testid="cv-dialog-download-button">
                <Download className="mr-2 h-4 w-4" /> {t("Descargar")}
              </Button>
            </DialogHeader>
            {url && <iframe title="CV" src={url} className="w-full flex-1 rounded-xl border border-slate-200 bg-slate-100" data-testid="cv-dialog-iframe" />}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
